import {
  getPresetRange,
  isCustomPreset,
  parsePresetToken,
} from '@app/components/date-range-selector/date-range-presets';
import { mapStationFilterOptionsTo } from '@app/components/stations/advanced-filter';
import { StreamQualityReportValues } from './types';
import { StreamQualityReportBodyDto } from '../stream-quality.types';

/**
 * Builds the POST body for `/stream-quality/report` from report form values.
 * For relative presets (e.g. last24Hours), from/to are recomputed at call time so a stale
 * form kept open for hours always sends the correct window rather than mount-time values.
 */
export function mapStreamQualityValuesToRequest(
  values: StreamQualityReportValues,
  timezone: string,
): StreamQualityReportBodyDto {
  const rawPreset = values.dateRange.preset;
  const preset = typeof rawPreset === 'string' ? parsePresetToken(rawPreset) : rawPreset;
  let from = values.dateRange.from ?? '';
  let to = values.dateRange.to ?? '';

  if (preset && !isCustomPreset(preset)) {
    const range = getPresetRange(preset, timezone);
    if (range) {
      from = range.from.toISOString();
      to = range.to.toISOString();
    }
  }

  return {
    from,
    to,
    stationsFilters: mapStationFilterOptionsTo<StreamQualityReportBodyDto['stationsFilters']>(
      values.stationsFilter ?? [],
    ),
  };
}
